import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Eye, EyeOff, Mail, Lock } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { useScreenInit } from '../../useScreenInit';
export function Login() {
  useScreenInit();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate login and go to dashboard
    navigate('/app');
  };
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-128">
      <header className="px-4 py-4 flex items-center" data-id="element-129">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-text-secondary hover:text-text-primary" data-id="element-130">
          <ChevronLeft className="w-6 h-6" data-id="element-131" />
        </button>
      </header>

      <main className="flex-1 px-6 py-4 flex flex-col" data-id="element-132">
        <div className="mb-8" data-id="element-133">
          <h1 className="text-3xl font-heading font-bold text-text-primary mb-2" data-id="element-134">
            Welcome Back
          </h1>
          <p className="text-text-secondary" data-id="element-135">
            Log in to continue your journey.
          </p>
        </div>

        <form onSubmit={handleLogin} className="space-y-5 flex-1" data-id="element-136">
          <div data-id="element-137">
            <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-138">
              Email or Phone Number
            </label>
            <div className="relative" data-id="element-139">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-text-secondary" data-id="element-140">
                <Mail className="w-5 h-5" data-id="element-141" />
              </div>
              <input type="text" placeholder="Enter your email or phone" className="w-full pl-11 pr-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary focus:border-transparent transition-all outline-none text-text-primary" required data-id="element-142" />
            </div>
          </div>

          <div data-id="element-143">
            <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-144">
              Password
            </label>
            <div className="relative" data-id="element-145">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-text-secondary" data-id="element-146">
                <Lock className="w-5 h-5" data-id="element-147" />
              </div>
              <input type={showPassword ? 'text' : 'password'} placeholder="Enter your password" className="w-full pl-11 pr-12 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary focus:border-transparent transition-all outline-none text-text-primary" required data-id="element-148" />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-4 flex items-center text-text-secondary hover:text-text-primary" data-id="element-149">
                {showPassword ? <EyeOff className="w-5 h-5" data-id="element-150" /> : <Eye className="w-5 h-5" data-id="element-151" />}
              </button>
            </div>
          </div>

          <div className="flex justify-end" data-id="element-152">
            <button type="button" onClick={() => navigate('/forgot-password')} className="text-sm font-semibold text-brand-primary hover:underline" data-id="element-153">
              Forgot Password?
            </button>
          </div>

          <div className="pt-4" data-id="element-154">
            <Button type="submit" fullWidth size="lg" data-id="element-155">
              Log In
            </Button>
          </div>
        </form>

        <div className="mt-auto pt-8 pb-6 text-center" data-id="element-156">
          <p className="text-sm text-text-secondary" data-id="element-157">
            Don't have an account?{' '}
            <button onClick={() => navigate('/select-user-type')} className="font-semibold text-brand-primary hover:underline" data-id="element-158">
              Register here
            </button>
          </p>
        </div>
      </main>
    </div>;
}